import React from 'react';
import { colors } from '@peachjar/components';
// remove default portion later
const { silver } = colors;

const HorizontalRule = ({ margin }) => (
  <div
    style={{
      height: '1px',
      backgroundColor: silver,
      margin,
    }}
  />
);

export default HorizontalRule;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/HorizontalRule.jsx